<div class="fullscreen-dialog-wrapper">
  @if (!loadingData()) {
    <h1 mat-dialog-title>
      <div class="title-content">
        <span>{{ dialogTitle }}</span>
        @if (roles && roles.length > 0) {
          <mat-chip-set>
            @for (role of roles; track role) {
              <mat-chip matTooltip="De passagier heeft ook deze rol">
                {{ roleLabels[role] }}
              </mat-chip>
            }
          </mat-chip-set>
        }
      </div>
      <div class="title-buttons">
        <button mat-icon-button aria-label="Sluiten" mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </h1>

    <div mat-dialog-content [formGroup]="userForm">
      <mat-tab-group [selectedIndex]="selectedIndex()" (selectedTabChange)="selectedIndex.set($event.index)">
        <!-- Tab 0: Persoonsgegevens -->
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-label">
              @if (showTabAttention('personal')) {
                <mat-icon
                  [class]="
                    hasTabValidationIssues('personal')
                      ? 'tab-warning-icon tab-attention-critical'
                      : 'tab-warning-icon tab-attention-info'
                  "
                  [matTooltip]="getTabAttentionTooltip('personal') || null"
                >
                  {{ hasTabValidationIssues('personal') ? 'warning' : 'info' }}
                </mat-icon>
              }
              <span>Persoonsgegevens</span>
            </div>
          </ng-template>
          <div class="tab-content personal-tab-content">
            <div class="fields-wrapping">
              <mat-form-field>
                <mat-label>Voor- en achternaam</mat-label>
                <input formControlName="name" type="text" matInput required />
                @if (userForm.controls.name.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>E-mailadres</mat-label>
                <input
                  formControlName="email"
                  autocomplete="one-time-code"
                  matInput
                  [required]="isEmailSignInRequired"
                  type="email"
                />
                @if (
                  !newUser &&
                  isEmailSignInRequired &&
                  !isOnlyRidePlanner() &&
                  (dataStore.orgUser?.roles?.includes(Role.Administrator) || dataStore.rootUser?.rights === 'admin')
                ) {
                  <button matSuffix mat-icon-button aria-label="Veld bewerken" (click)="enableField('email')">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                @if (userForm.controls.email.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
                @if (userForm.controls.email.hasError('email')) {
                  <mat-error>E-mailadres is ongeldig.</mat-error>
                }
                @if (!isEmailSignInRequired) {
                  <mat-hint>Optioneel</mat-hint>
                }
              </mat-form-field>
              @if (newUser) {
                <mat-form-field>
                  <mat-label>Wachtwoord</mat-label>
                  <input formControlName="password" autocomplete="new-password" matInput required minlength="6" />
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    aria-label="Genereer willekeurig wachtwoord"
                    (click)="generatePassword()"
                    matTooltip="Genereer een willekeurig wachtwoord"
                  >
                    <mat-icon>autorenew</mat-icon>
                  </button>
                  @if (userForm.controls.password.hasError('required')) {
                    <mat-error>Dit veld is verplicht.</mat-error>
                  }
                  @if (userForm.controls.password.hasError('minlength')) {
                    <mat-error>Het wachtwoord moet minimaal 6 tekens bevatten.</mat-error>
                  }
                </mat-form-field>
              }
              <mat-form-field>
                <mat-label>Telefoonnummer</mat-label>
                <input
                  placeholder="06 11223344"
                  type="tel-national"
                  formControlName="phoneNumber"
                  matInput
                  [required]="isPhoneSignInRequired"
                />
                @if (
                  !newUser &&
                  isPhoneSignInRequired &&
                  !isOnlyRidePlanner() &&
                  (dataStore.orgUser?.roles?.includes(Role.Administrator) || dataStore.rootUser?.rights === 'admin')
                ) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Telefoonnummer bewerken"
                    (click)="enableField('phoneNumber')"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                @if (!isPhoneSignInRequired) {
                  <mat-hint>Optioneel</mat-hint>
                }
                @if (userForm.controls.phoneNumber.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
                @if (userForm.controls.phoneNumber.hasError('phoneValidator')) {
                  <mat-error>Telefoonnummer is ongeldig.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Kaartnummer</mat-label>
                <input formControlName="cardId" matInput />
                <mat-hint>Optioneel</mat-hint>
              </mat-form-field>
              @if (askGender) {
                <mat-form-field>
                  <mat-label>Geslacht</mat-label>
                  <mat-select formControlName="gender">
                    <mat-option value="Man">Man</mat-option>
                    <mat-option value="Vrouw">Vrouw</mat-option>
                    <mat-option value="Anders">Anders</mat-option>
                  </mat-select>
                  @if (userForm.controls.gender.hasError('required')) {
                    <mat-error>Dit veld is verplicht.</mat-error>
                  }
                </mat-form-field>
              }
              @if (askBirthDate) {
                <mat-form-field>
                  <mat-label>Geboortedatum</mat-label>
                  <input formControlName="birthDate" matInput [matDatepicker]="picker" required />
                  <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  @if (userForm.controls.birthDate.hasError('required')) {
                    <mat-error>Dit veld is verplicht.</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <h2>Adresgegevens</h2>
            <div class="fields-row static-row">
              <mat-form-field>
                <mat-label>Postcode</mat-label>
                <input formControlName="postal" matInput #postalCode required />
                @if (userForm.controls.postal.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
                @if (userForm.controls.postal.hasError('postalValidator')) {
                  <mat-error>Postcode is ongeldig.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Huisnummer</mat-label>
                <input formControlName="houseNumber" matInput required />
                @if (userForm.controls.houseNumber.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
                @if (userForm.controls.houseNumber.hasError('numberInput')) {
                  <mat-error>Huisnummer is ongeldig.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Toevoeging</mat-label>
                <input formControlName="houseNumberAddition" matInput />
                <mat-hint>Optioneel</mat-hint>
              </mat-form-field>
            </div>
            <div class="fields-row">
              <mat-form-field class="double-width lookup-container">
                <mat-label>Straatnaam</mat-label>
                <input formControlName="streetName" matInput required />
                @if (isLookingUp()) {
                  <div matSuffix class="lookup-spinner">
                    <mat-spinner diameter="20"></mat-spinner>
                  </div>
                }
                @if (userForm.controls.streetName.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="lookup-container">
                <mat-label>Woonplaats</mat-label>
                <input formControlName="city" matInput required />
                @if (isLookingUp()) {
                  <div matSuffix class="lookup-spinner">
                    <mat-spinner diameter="20"></mat-spinner>
                  </div>
                }
                @if (userForm.controls.city.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
              </mat-form-field>
            </div>
            @if (addressNotFound()) {
              <div class="address-warning">
                <mat-icon>warning</mat-icon>
                <span
                  >Adres niet gevonden. Controleer of de postcode en het huisnummer correct zijn ingevuld of vul
                  handmatig de straatnaam en woonplaats in.</span
                >
              </div>
            }
            <mat-form-field>
              <mat-label>Opmerking (Algemeen)</mat-label>
              <textarea formControlName="hiddenRemarks" matInput rows="3"></textarea>
              <mat-hint>Optioneel</mat-hint>
            </mat-form-field>

            <div class="emergency-numbers-button-wrapper">
              <button mat-flat-button class="secondary-color" (click)="openEmergencyNumbersDialog()" type="button">
                Noodnummers ({{ emergencyPhoneNumbers().length }})
              </button>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 1: Ritgegevens -->
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-label">
              @if (showTabAttention('ride')) {
                <mat-icon
                  [class]="
                    hasTabValidationIssues('ride')
                      ? 'tab-warning-icon tab-attention-critical'
                      : 'tab-warning-icon tab-attention-info'
                  "
                  [matTooltip]="getTabAttentionTooltip('ride') || null"
                >
                  {{ hasTabValidationIssues('ride') ? 'warning' : 'info' }}
                </mat-icon>
              }
              <span>Ritgegevens</span>
            </div>
          </ng-template>
          <div class="tab-content">
            @if (particularitiesArray.length > 0) {
              <p>Bijzonderheden</p>
              <div class="icons">
                @for (particularity of particularitiesArray; track particularity) {
                  <div
                    class="icon"
                    [ngClass]="{ active: userForm.value.particularityIds.includes(particularity.id) }"
                    [matTooltip]="particularity.name"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="
                      userForm.value.particularityIds.includes(particularity.id)
                        ? 'Bijzonderheid deselecteren: ' + particularity.name
                        : 'Bijzonderheid selecteren: ' + particularity.name
                    "
                    [attr.aria-pressed]="userForm.value.particularityIds.includes(particularity.id)"
                    (click)="toggleParticularity(particularity.id!)"
                    (keydown.enter)="toggleParticularity(particularity.id!)"
                    (keydown.space)="$event.preventDefault(); toggleParticularity(particularity.id!)"
                  >
                    <mat-icon [svgIcon]="particularity.id!"></mat-icon>
                  </div>
                }
              </div>
            }
            <div class="fields-row">
              @if (dataStore.paidFunctionalities?.usesAutomaticPlanning) {
                <mat-form-field>
                  <mat-label>Instaptijd (minuten)</mat-label>
                  <input formControlName="vehicleEntryDuration" matInput type="text" autocomplete="off" />
                  @if (userForm.controls.vehicleEntryDuration.hasError('max')) {
                    <mat-error>De instaptijd mag niet meer dan 15 minuten zijn.</mat-error>
                  } @else if (userForm.controls.vehicleEntryDuration.hasError('numberInput')) {
                    <mat-error>Vul een geldige waarde in.</mat-error>
                  }
                </mat-form-field>
              }
              @if (dataStore.paidFunctionalities?.usesAutomaticPlanning) {
                <mat-form-field>
                  <mat-label>Uitstaptijd (minuten)</mat-label>
                  <input formControlName="vehicleExitDuration" matInput type="text" autocomplete="off" />
                  @if (userForm.controls.vehicleExitDuration.hasError('max')) {
                    <mat-error>De uitstaptijd mag niet meer dan 15 minuten zijn.</mat-error>
                  } @else if (userForm.controls.vehicleExitDuration.hasError('numberInput')) {
                    <mat-error>Vul een geldige waarde in.</mat-error>
                  }
                </mat-form-field>
              }
              <mat-form-field>
                <mat-label>Standaard ritprijs</mat-label>
                <mat-select formControlName="rideProductId">
                  <mat-option [value]="'none'">Geen </mat-option>
                  @for (product of productArray(); track product) {
                    <mat-option [value]="product.id">{{ product.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (planningComments) {
              <mat-form-field>
                <mat-label>Opmerking (Planner)</mat-label>
                <textarea formControlName="remarks" rows="3" matInput></textarea>
              </mat-form-field>
            }
            @if (driverComments) {
              <mat-form-field>
                <mat-label>Opmerking (Voor chauffeur)</mat-label>
                <textarea formControlName="commentsForDriver" rows="3" matInput></textarea>
              </mat-form-field>
            }
          </div>
        </mat-tab>

        <!-- Tab 2: Betaalgegevens -->
        @if (!isOnlyRidePlanner()) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="tab-label">
                @if (showTabAttention('payment')) {
                  <mat-icon
                    [class]="
                      hasTabValidationIssues('payment')
                        ? 'tab-warning-icon tab-attention-critical'
                        : 'tab-warning-icon tab-attention-info'
                    "
                    [matTooltip]="getTabAttentionTooltip('payment') || null"
                  >
                    {{ hasTabValidationIssues('payment') ? 'warning' : 'info' }}
                  </mat-icon>
                }
                <span>Betaalgegevens</span>
              </div>
            </ng-template>
            <div class="tab-content">
              <div class="fields-row">
                <mat-form-field>
                  <mat-label>Betaalmethode</mat-label>
                  <mat-select formControlName="paymentMethod">
                    <mat-option [value]="paymentMethod.NONE"> Geen </mat-option>
                    @if (data.publicSettings.mollieEnabled) {
                      <mat-option [disabled]="!data.user?.mollieCustomerID" [value]="paymentMethod.MOLLIE">
                        Mollie
                      </mat-option>
                    }
                    @if (data.publicSettings.sepaEnabled) {
                      <mat-option [disabled]="!sepaPath()" [value]="paymentMethod.SEPA"> SEPA </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (data.publicSettings.sepaEnabled) {
                  <mat-form-field>
                    <mat-label>IBAN</mat-label>
                    <input formControlName="iban" matInput />
                  </mat-form-field>
                }
                <mat-form-field>
                  <mat-label>Betaalplan</mat-label>
                  <mat-select formControlName="currentPlan">
                    <mat-option [value]="'none'">Geen </mat-option>
                    @for (plan of planArray(); track plan) {
                      <mat-option [value]="plan.id">{{ plan.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              @if (
                data.publicSettings.sepaEnabled &&
                userForm.controls.paymentMethod.value === paymentMethod.SEPA &&
                userForm.controls.currentPlan.value !== 'none' &&
                userForm.controls.iban.valid &&
                userForm.controls.iban.value?.length > 0
              ) {
                <button mat-flat-button class="secondary-color sepa-button" (click)="downloadSepa()" type="button">
                  <mat-icon>download</mat-icon>Download
                  {{ sepaPath() === 'sepa_authorization.pdf' ? 'Nieuw' : 'huidige' }} SEPA formulier
                </button>
                @if (sepaPath() === 'sepa_authorization.pdf') {
                  @if (sepaMandateId()) {
                    <button
                      mat-flat-button
                      class="secondary-color sepa-button"
                      (click)="openFileInput('pdf')"
                      type="button"
                    >
                      <mat-icon>upload</mat-icon>Upload SEPA formulier
                    </button>
                  }
                } @else {
                  <button
                    mat-flat-button
                    class="secondary-color sepa-button"
                    (click)="openFileInput('pdf')"
                    type="button"
                  >
                    <mat-icon>upload</mat-icon>Wijzig SEPA formulier
                  </button>
                  <button mat-stroked-button class="sepa-button error-color" (click)="deleteSepa()" type="button">
                    <mat-icon>delete</mat-icon>Verwijder SEPA formulier
                  </button>
                }
              }

              @if (data.user?.warnings && data.user?.warnings?.length! > 0) {
                <div class="warnings-section">
                  <h2>Meldingen</h2>
                  <div class="warnings-list">
                    @for (warning of data.user?.warnings; track warning) {
                      <div class="warning-item">
                        <div class="notification-circle-icon" [ngClass]="warning.colorClass">
                          {{ warning.type === 'text' ? warning.iconOrText : '' }}
                          @if (warning.type === 'icon') {
                            <mat-icon>{{ warning.iconOrText }}</mat-icon>
                          }
                        </div>
                        <span class="warning-text">{{ warning.description }}</span>
                      </div>
                    }
                  </div>
                </div>
              }

              <input
                class="hidden-file-input"
                type="file"
                id="pdf"
                (change)="uploadSepa($event)"
                accept=".pdf"
                style="display: none"
              />
            </div>
          </mat-tab>
        }

        <!-- Tab 3: Notificaties -->
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-label">
              @if (showTabAttention('notifications')) {
                <mat-icon
                  [class]="
                    hasTabValidationIssues('notifications')
                      ? 'tab-warning-icon tab-attention-critical'
                      : 'tab-warning-icon tab-attention-info'
                  "
                  [matTooltip]="getTabAttentionTooltip('notifications') || null"
                >
                  {{ hasTabValidationIssues('notifications') ? 'warning' : 'info' }}
                </mat-icon>
              }
              <span>Notificaties</span>
            </div>
          </ng-template>
          <div class="tab-content">
            <div class="notifications-list">
              @if (smsNotificationsParticipants) {
                <mat-form-field>
                  <mat-label>Telefoonnummer voor SMS</mat-label>
                  <input
                    placeholder="06 11223344"
                    type="tel-national"
                    formControlName="smsNotificationPhoneNumber"
                    matInput
                  />
                  @if (userForm.controls.smsNotificationPhoneNumber.hasError('phoneValidator')) {
                    <mat-error>Telefoonnummer is ongeldig.</mat-error>
                  }
                </mat-form-field>
              }
              @if (smsNotificationsParticipants) {
                <mat-checkbox formControlName="notifyBySMS"> Notificatie via SMS </mat-checkbox>
              }
              @if (userForm.controls.notifyBySMS?.value) {
                <div class="notification-options">
                  <mat-checkbox formControlName="notifyBySMSRideConfirmed"> Ritbevestiging </mat-checkbox>
                  <mat-checkbox formControlName="notifyBySMSRideChanged"> Ritwijziging </mat-checkbox>
                  <mat-checkbox formControlName="notifyBySMSRideDeleted"> Rit verwijderd </mat-checkbox>
                  <mat-checkbox formControlName="notifyBySMSRideReminder"> Voor aanvang van rit </mat-checkbox>
                </div>
              }
              @if (emailNotificationsParticipants) {
                <mat-checkbox formControlName="notifyByEmail"> Notificatie via E-mail </mat-checkbox>
              }
              @if (userForm.controls.notifyByEmail?.value) {
                <div class="notification-options">
                  <mat-checkbox formControlName="notifyByEmailRideConfirmed"> Ritbevestiging </mat-checkbox>
                  <mat-checkbox formControlName="notifyByEmailRideChanged"> Ritwijziging </mat-checkbox>
                  <mat-checkbox formControlName="notifyByEmailRideDeleted"> Rit verwijderd </mat-checkbox>
                  <mat-checkbox formControlName="notifyByEmailRideReminder"> Voor aanvang van rit </mat-checkbox>
                </div>
              }
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Annuleren</button>
      <div class="navigation-buttons">
        <button mat-stroked-button (click)="prevTab()" [disabled]="selectedIndex() === 0">Vorige</button>
        <button mat-stroked-button (click)="nextTab()" [disabled]="selectedIndex() === maxTabIndex()">Volgende</button>
        <button
          mat-flat-button
          class="primary-color"
          [disabled]="userForm.invalid"
          (click)="save()"
          [class.spinner]="loading()"
        >
          Opslaan
        </button>
      </div>
    </div>
  } @else {
    <div class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
